import { ActionTypes } from '../constans/action-types';

const initialState = {
  isRecording: false, // Mic recording on/off
  recordingTime: 0, // Elapsed time in seconds
  content: '', // Full transcript content (combined)
  transcript: [], // Optional: Array of lines/
  isEditingTitle: false,
  paused: false, // If paused
  stopped: false, // If stopped
  meetingTitle: 'Untitled Meeting',
  micDevice: 'default', // Selected mic device
  summary: '',
  meeting_id: '',
  start_time: '',
  meetingContext: '',
  isStarted: false,
  microPhoneList: [],
  parentMeetId: '',
  websocketConnection: false,
  audioControlDisabled: false,
  manualPause: false,
  fromHistoryResume: false,
  isFinalizing: false,
  // VAD (Voice Activity Detection) state
  autoPaused: false, // Paused due to inactivity
  vadEnabled: true, // User preference
  // silenceThresholdMs: 10000, // Configurable threshold (2 minutes default)
  lastAutoStopReason: null, // 'inactivity' | 'manual' | null
  shouldOpenSummarizeDialog: false, // Flag to trigger summarize dialog
  resumeWaitingForServer: false, // True while waiting for recording_id before resume reconnect
  noRecordingExpected: false, // True when server reported LOW_SIGNAL_AUDIO / NO_VOICE_ACTIVITY / etc. – no loader, show snackbar without waiting
};

const globalRecordingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_CURRENT_RECORDING:
      const payload = action.payload;

      let nextState = { ...state };

      if (Object.prototype.hasOwnProperty.call(payload, 'transcript')) {
        nextState.transcript =
          typeof payload.transcript === 'function'
            ? payload.transcript(state.transcript)
            : (payload.transcript ?? state.transcript);
      } else if (
        Object.prototype.hasOwnProperty.call(payload, 'transcriptAppend')
      ) {
        const prevTranscript = Array.isArray(state.transcript)
          ? state.transcript
          : [];
        if (payload.transcriptAppend !== undefined) {
          nextState.transcript = [...prevTranscript, payload.transcriptAppend];
        }
      }

      if (Object.prototype.hasOwnProperty.call(payload, 'content')) {
        nextState.content =
          typeof payload.content === 'function'
            ? payload.content(state.content)
            : (payload.content ?? state.content);
      } else if (Object.prototype.hasOwnProperty.call(payload, 'contentAppend')) {
        const prevContent = state.content || '';
        if (payload.contentAppend !== undefined) {
          nextState.content = `${prevContent}${payload.contentAppend}`;
        }
      }

      return {
        ...nextState,
        // Spread the rest (e.g. isRecording, paused, etc.)
        ...Object.fromEntries(
          Object.entries(payload).filter(
            ([key]) =>
              key !== 'transcript' &&
              key !== 'content' &&
              key !== 'transcriptAppend' &&
              key !== 'contentAppend'
          )
        ),
      };
    case ActionTypes.RESET_RECORDING: // Reset the state to initialState
      return initialState;
    default:
      return state;
  }
};

// const globalRecordingReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case ActionTypes.SET_CURRENT_RECORDING:
//       return {
//         ...state,
//         ...action.payload, // safely update any/all of isRunning, content, timer
//       };
//     default:
//       return state;
//   }
// };

export default globalRecordingReducer;
